<div class="header-container fx-layout-row fx-justify-start fx-align-center fx-gap-10">
  @if (work) {
    <div class="work-action-block page-title">
      <div>{{ work?.toString() }}</div>
    </div>
    <div class="work-state-block">
      <div>{{ work.state.toString() }}</div>
    </div>
  }

  <div class="fx-flex"></div>
  <workflow-buttons
    [entityType]="EntityType.WORK"
    [view]="ManualWorkflowViewEnum.SHEET"
    [selectedEntityIds]="[work?.id]">
  </workflow-buttons>
  <div id="work-menu" class="fx-layout-row">
    <restricted-icon-button [class]="'mdi mdi-dots-vertical sm'" [id]="'work-sheet-menu-button'" [matMenuTriggerFor]="menu"
    [preconditions]="(!!this?.work?.assetId && accessManager.hasAccess(Permission.VIEW_ASSET)) || accessManager.hasAccess(Permission.DELETE_WORK)"></restricted-icon-button>
    <mat-menu #menu="matMenu">
      <restricted-menu-item (onClick)="deleteWork()" [id]="'delete-work-menu'" [permissions]="[Permission.DELETE_WORK]"
        [preconditions]="true">
        {{'BUTTON.DELETE_WORK' | translate}}
      </restricted-menu-item>

      @if (!!this?.work?.assetId) {
        <restricted-menu-item (onClick)="showAssetSheet()" [id]="'show_asset_sheet_menu'"
          [permissions]="[Permission.VIEW_ASSET]" [preconditions]="true">
          {{'BUTTON.SHOW_ASSET_SHEET' | translate}}
        </restricted-menu-item>
      }
    </mat-menu>
  </div>
</div>
